<script>
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';

export default class NxtsofService extends Vue {
  static getAllNxtsofFis() {
    const response = axios.get('/api/nxtsof/fi/v1').then((data) => {
      if (data.data === null) {
        return [];
      }
      return data.data.fiIds;
    });
    return response;
  }

  static updateNxtsofFiid(nxtsofPayload) {
    const payload = {};
    const keys = Object.keys(nxtsofPayload);
    const values = Object.values(nxtsofPayload);
    for (let i = 0; i < keys.length; i++) {
      payload[keys[i]] = values[i];
    }
    console.log('Submitting info');
    axios
      .put('/api/nxtsof/fi/', payload);
  }
}
</script>
